import { MessageSquareWarning } from 'lucide-react';
import { toast } from 'sonner';
import { useRecadosSupervisora } from '@/hooks/useBackofficePlacar';
import { useUserProfile } from '@/hooks/useUserProfile';

/* A cobrança da supervisora na tela da pessoa (Douglas 22/10/2026): fica em cima
   de tudo, inclusive da trava, até ela marcar que leu. É o caminho quando a
   pessoa não tem linha própria no CRM, e a confirmação de leitura quando tem. */

const hora = (iso: string) => new Date(iso).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', timeZone: 'America/Sao_Paulo' });

export function RecadoDaSupervisora() {
  const { data: perfil } = useUserProfile();
  const funcao = perfil?.funcao ?? '';
  const aplica = funcao.startsWith('BKO') || funcao.startsWith('ANALISTA_QUALIDADE');
  const { recados, marcarLido } = useRecadosSupervisora(aplica);
  if (!aplica || recados.length === 0) return null;
  const r = recados[0];
  const ler = () => marcarLido.mutate(r.id, { onError: (e) => toast.error(e instanceof Error ? e.message : 'Não foi possível marcar como lido.') });
  return (
    <div role="alertdialog" aria-labelledby="recado-supervisora-titulo"
      className="fixed left-1/2 top-3 z-[9600] w-[min(94vw,640px)] -translate-x-1/2 overflow-hidden rounded-xl border border-border-warm bg-card shadow-[0_12px_40px_-12px_rgba(0,0,0,0.35)]">
      <div className="flex items-center gap-2 bg-[linear-gradient(150deg,#5E1424,#3E0E1B)] px-4 py-2.5 text-white">
        <MessageSquareWarning className="h-4 w-4 shrink-0" />
        <p id="recado-supervisora-titulo" className="min-w-0 flex-1 text-[12.5px] font-bold">
          Recado de {r.autor.split(' ')[0]} · {hora(r.criado_em)}{recados.length > 1 ? ` · mais ${recados.length - 1}` : ''}
        </p>
      </div>
      <p className="whitespace-pre-wrap px-4 py-3 text-[13px]">{r.texto}</p>
      <div className="flex justify-end border-t border-border px-4 py-2.5">
        <button type="button" onClick={ler} disabled={marcarLido.isPending}
          className="h-9 rounded-lg bg-[linear-gradient(135deg,#4A1320,#5B0A0D)] px-4 text-[12.5px] font-bold text-white transition hover:brightness-110 disabled:opacity-60 dark:bg-[linear-gradient(135deg,#9D2530,#6C2236)]">
          Li o recado
        </button>
      </div>
    </div>
  );
}
